export const portfolioItems = [
  {
    id: 1,
    title: "Trending Personal Reel",
    category: "Reels / Shorts",
    thumbnail: "https://img.youtube.com/vi/VkkcaN34Pmo/maxresdefault.jpg",
    videoUrl: "https://youtube.com/shorts/VkkcaN34Pmo",
    videoId: "VkkcaN34Pmo",
    duration: "1:00",
    description: "Viral-ready content"
  },
  {
    id: 2,
    title: "Trackday Recap",
    category: "Reels / Shorts",
    thumbnail: "https://img.youtube.com/vi/JTEby3RoXvk/maxresdefault.jpg",
    videoUrl: "https://youtube.com/shorts/JTEby3RoXvk",
    videoId: "JTEby3RoXvk",
    duration: "0:40",
    description: "High-octane trackday highlights"
  },
  {
    id: 3,
    title: "Stokker x Valvoline @ RX Night Race Finals 2025",
    category: "Reels / Shorts",
    thumbnail: "https://img.youtube.com/vi/2ZhZavzBm5k/maxresdefault.jpg",
    videoUrl: "https://youtube.com/shorts/2ZhZavzBm5k",
    videoId: "2ZhZavzBm5k",
    duration: "0:45",
    description: "Event coverage"
  },
  {
    id: 4,
    title: "Karcher Campaign",
    category: "Events",
    thumbnail: "https://img.youtube.com/vi/WIcBZxqZckI/maxresdefault.jpg",
    videoUrl: "https://youtu.be/WIcBZxqZckI",
    videoId: "WIcBZxqZckI",
    duration: "1:15",
    description: "Event recap for brand campaign"
  },
  {
    id: 5,
    title: "King Of Kings - 2025 - Riga, Latvia",
    category: "Events",
    thumbnail: "https://img.youtube.com/vi/1pLoASAFvAY/maxresdefault.jpg",
    videoUrl: "https://youtu.be/1pLoASAFvAY",
    videoId: "1pLoASAFvAY",
    duration: "3:30",
    description: "Recap of highlights"
  },
  {
    id: 6,
    title: "InterCars x Delphi - Elektro orientēšanās diena",
    category: "Events",
    thumbnail: "https://img.youtube.com/vi/uvJN1_hlsu4/maxresdefault.jpg",
    videoUrl: "https://youtu.be/uvJN1_hlsu4",
    videoId: "uvJN1_hlsu4",
    duration: "2:45",
    description: "Event coverage"
  },
  {
    id: 7,
    title: "Stokker x Valvoline @ RX Night Race Finals 2025",
    category: "Events",
    thumbnail: "https://img.youtube.com/vi/Q2-o7cOpQEs/maxresdefault.jpg",
    videoUrl: "https://youtu.be/Q2-o7cOpQEs",
    videoId: "Q2-o7cOpQEs",
    duration: "3:15",
    description: "Event coverage"
  },
  {
    id: 8,
    title: "Studio Space Concert",
    category: "Events",
    thumbnail: "https://img.youtube.com/vi/99LBoQX62zI/maxresdefault.jpg",
    videoUrl: "https://youtu.be/99LBoQX62zI",
    videoId: "99LBoQX62zI",
    duration: "2:20",
    description: "Event Coverage"
  },
  {
    id: 9,
    title: "GS VALUE",
    category: "Commercial",
    thumbnail: "https://img.youtube.com/vi/Wi3wvucf2FQ/maxresdefault.jpg",
    videoUrl: "https://youtu.be/Wi3wvucf2FQ",
    videoId: "Wi3wvucf2FQ",
    duration: "1:30",
    description: "Promo video for new fishing rod"
  },
  {
    id: 10,
    title: "LIVE.",
    category: "Cinematic",
    thumbnail: "https://img.youtube.com/vi/THYYvYBFJtM/maxresdefault.jpg",
    videoUrl: "https://youtu.be/THYYvYBFJtM",
    videoId: "THYYvYBFJtM",
    duration: "2:00",
    description: "Tribute"
  },
  {
    id: 11,
    title: "KARCHER PRODUCTION",
    category: "Commercial",
    thumbnail: "https://img.youtube.com/vi/DXEJdC4w6TY/maxresdefault.jpg",
    videoUrl: "https://youtu.be/DXEJdC4w6TY",
    videoId: "DXEJdC4w6TY",
    duration: "2:30",
    description: "How it's made"
  },
  {
    id: 12,
    title: "SUN GO",
    category: "Commercial",
    thumbnail: "https://img.youtube.com/vi/ylZBPvnc2uM/maxresdefault.jpg",
    videoUrl: "https://youtu.be/ylZBPvnc2uM",
    videoId: "ylZBPvnc2uM",
    duration: "1:45",
    description: "Brand video"
  }
];

export const services = [
  "Video Editing (Reels, TikTok, YouTube, Ads)",
  "Event Recaps & Aftermovies",
  "Brand & Promo Videos",
  "Social Media Content Packages",
  "Visual Design (Catalogs, Graphics, Branding)",
  "Fast Turnaround Editing"
];

export const whyWorkWithMe = [
  "Fast communication",
  "Reliable delivery",
  "Platform-aware editing",
  "10+ years of experience videography",
  "Turn-key video production",
  "Easy to work with"
];

export const processSteps = [
  {
    number: "01",
    title: "You send footage",
    description: "Share your raw files via cloud link or drive"
  },
  {
    number: "02",
    title: "I edit & refine",
    description: "Fast turnaround, clear communication, your vision in focus"
  },
  {
    number: "03",
    title: "Final delivery",
    description: "Platform-ready videos, optimized and ready to publish"
  }
];

export const productionSteps = [
  {
    number: "01",
    title: "We define the idea",
    description: "Goals, format, platform and visual direction"
  },
  {
    number: "02",
    title: "I film & produce",
    description: "On-location filming with a clean, efficient setup"
  },
  {
    number: "03",
    title: "I edit & deliver",
    description: "High-impact, platform-ready video content"
  }
];
